import React from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  const cvdsIcon = require("../assets/logos/cvdsLogoCropped.png");
  const year = new Date().getFullYear();

  const footerLinks = [
    { label: "About", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Portfolio", path: "/portfolio" },
    { label: "Apps", path: "/apps" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <footer style={styles.footer}>
      <Container>
        <Row className="align-items-center py-4">
          <Col xs={12} md={7} className="mb-4 mb-md-0">
            <p style={styles.howHelp}>Have a project in mind?</p>
            <p style={styles.subline}>
              Tell us about it and we&apos;ll get back to you within one
              business day.
            </p>
            <Button
              variant="primary"
              as={Link}
              to="/contact"
              style={styles.ctaButton}
            >
              Plan your project
            </Button>
          </Col>
          <Col xs={12} md={5}>
            <Row>
              <Col xs={6}>
                <p style={styles.colHeader}>Company</p>
                {footerLinks.map((item) => (
                  <p key={item.path} style={styles.linkRow}>
                    <Link to={item.path} className="footer-link">
                      {item.label}
                    </Link>
                  </p>
                ))}
              </Col>
              <Col xs={6}>
                <p style={styles.colHeader}>What we do</p>
                <p style={styles.serviceItem}>Mobile App Development</p>
                <p style={styles.serviceItem}>Web Development</p>
                <p style={styles.serviceItem}>Web Hosting &amp; Maintenance</p>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr style={styles.divider} />
        <Row className="align-items-center pb-3">
          <Col xs={12} md={6} className="text-center text-md-start mb-2 mb-md-0">
            <Image
              src={cvdsIcon}
              height="20"
              alt="Cross Vision Development Studios"
            />
          </Col>
          <Col xs={12} md={6} className="text-center text-md-end">
            <p style={styles.legal}>
              &copy; {year} Cross Vision Development Studios, a DBA of ACJ
              Operations, LLC. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;

const styles = {
  colHeader: {
    color: "#CF3620",
    fontSize: 14,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 1,
    marginBottom: 12,
  },
  ctaButton: {
    minWidth: 170,
    fontWeight: 600,
  },
  divider: {
    borderColor: "#4A443F",
    opacity: 1,
    margin: 0,
    marginBottom: 16,
  },
  footer: {
    background: "#1C1816",
    color: "#FFF",
    paddingTop: 24,
    textAlign: "left",
  },
  howHelp: {
    fontSize: 30,
    fontWeight: 700,
    marginBottom: 4,
  },
  legal: {
    color: "#ACACAC",
    fontSize: 13,
    marginBottom: 0,
  },
  linkRow: {
    marginBottom: 8,
  },
  serviceItem: {
    color: "#ACACAC",
    fontSize: 14,
    marginBottom: 8,
  },
  subline: {
    color: "#ACACAC",
    fontSize: 16,
    marginBottom: 16,
  },
};
